<template>
  <v-dialog
    v-model="visible"
    persistent
    fullscreen
    content-class="loading-dialog"
    transition="false"
  >
    <v-container fill-height>
      <v-layout row justify-center align-center>
        <v-progress-circular indeterminate :size="50" :width="7" color="purple"></v-progress-circular>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  name: "ProgressDialog",
  data() {
    return {
      visible: false
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    }
  }
};
</script>
